// Toggle Drawer

import { TOGGLE_DRAWER } from "./actionTypes";

export const toggleDrawer = () => ({
    type: TOGGLE_DRAWER,
  });